import { createFileRoute } from '@tanstack/react-router';
import { CustomPointsTransactionPage } from './CustomPointsTransactionPage';
import { z } from 'zod';

const searchSchema = z.object({
  userId: z.string().optional(),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/custom-points-transaction/')(
  {
    component: CustomPointsTransactionPage,
    validateSearch: searchSchema,
  },
);
